import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as WeatherForecastsStore from '../store/WeatherForecasts';
class FetchData extends React.PureComponent {
    // This method is called when the component is first added to the document
    componentDidMount() {
        this.ensureDataFetched();
    }
    // This method is called when the route parameters change
    componentDidUpdate() {
        this.ensureDataFetched();
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", { id: "tabelLabel" }, "Weather forecast"),
            React.createElement("p", null, "This component demonstrates fetching data from the server and working with URL parameters."),
            this.renderForecastsTable(),
            this.renderPagination()));
    }
    ensureDataFetched() {
        const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
        this.props.requestWeatherForecasts(startDateIndex);
    }
    renderForecastsTable() {
        return (React.createElement("table", { className: 'table table-striped', "aria-labelledby": "tabelLabel" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Date"),
                    React.createElement("th", null, "Temp. (C)"),
                    React.createElement("th", null, "Temp. (F)"),
                    React.createElement("th", null, "Summary"))),
            React.createElement("tbody", null, this.props.forecasts.map((forecast) => React.createElement("tr", { key: forecast.date },
                React.createElement("td", null, forecast.date),
                React.createElement("td", null, forecast.temperatureC),
                React.createElement("td", null, forecast.temperatureF),
                React.createElement("td", null, forecast.summary))))));
    }
    renderPagination() {
        const prevStartDateIndex = (this.props.startDateIndex || 0) - 5;
        const nextStartDateIndex = (this.props.startDateIndex || 0) + 5;
        return (React.createElement("div", { className: "d-flex justify-content-between" },
            React.createElement(Link, { className: 'btn btn-outline-secondary btn-sm', to: `/fetch-data/${prevStartDateIndex}` }, "Previous"),
            this.props.isLoading && React.createElement("span", null, "Loading..."),
            React.createElement(Link, { className: 'btn btn-outline-secondary btn-sm', to: `/fetch-data/${nextStartDateIndex}` }, "Next")));
    }
}
export default connect((state) => state.weatherForecasts, // Selects which state properties are merged into the component's props
WeatherForecastsStore.actionCreators // Selects which action creators are merged into the component's props
)(FetchData);
//# sourceMappingURL=FetchData.js.map